<template>
  <ShopCountrySwitcher :config="config" />
</template>

<script>
import ShopCountrySwitcher from "../../components/ShopCountrySwitcher/ShopCountrySwitcher.vue";

export default {
  name: "app",
  components: {
    ShopCountrySwitcher
  },
  data() {
    return {
      config: JSON.parse(this.$options._parentVnode.data.props.config)
    };
  }
};
</script>
